<template lang="html">
  <div class="submenu p bb">
    <div class="arrow noselect" @click="isActive = !isActive">
      <h1 class="pr" v-if="isActive">&uarr;</h1>
      <h1 class="pr" v-else>&darr;</h1>
    </div>
    <div v-if="!isActive" @click="isActive = !isActive">
      <h1 class="pr">{{ pageName }}</h1>
    </div>
    <div v-if="isActive" class="submenu-inner" @click="isActive = false">
      <router-link
        v-for="subpage in items"
        :key="subpage.uid"
        class="uc fs-mid"
        :to="'/' + parent + '/' + subpage.uid"
      >
        {{ subpage.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parent: String,
    title: String,
    items: Array
  },
  data() {
    return {
      isActive: false
    };
  },
  computed: {
    pageName() {
      if (this.$route.name == "faculty") {
        return this.title;
      } else if (this.$route.name == "teaching") {
        return this.title;
      } else {
        var item = this.items.filter(
          page => page.uid == this.$route.params.id
        )[0];
        return item.title;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fs-mid {
  font-size: calc(1.5 * var(--fs));
  line-height: 1.2;
}
.submenu {
  display: flex;
  position: fixed;
  top: calc(var(--lh) + (2 * var(--fs)));
  width: 100%;
  background: white;
  z-index: 1;
  @media only screen and (min-width: 768px) {
    display: none;
  }
}
</style>
